import { useContext, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import TypeBar from "../components/TypeBar";
import BrandBar from "../components/BrandBar";
import DetailList from "../components/DetailList";
import SearchBar from "../components/SearchBar";
import { observer } from "mobx-react-lite";
import { Context } from "../index";
import { fetchBrands, fetchDetails, fetchTypes } from "../http/detailAPI";
import Pages from "../components/Pages";
import { LIMIT_PER_PAGE } from "../utils/consts";
import { TypeBarSkeleton, BrandBarSkeleton, DetailListSkeleton } from "../components/Skeleton";

const Shop = observer(() => {
  const { detail } = useContext(Context);
  useEffect(() => {
      const loadData = async () => {
        detail.setIsLoading(true);
        try {
          const [types, brands, detailsData] = await Promise.all([
            fetchTypes(),
            fetchBrands(),
            fetchDetails(
              detail.selectedType.id || null,
              detail.selectedSubType.id || null,
              detail.selectedBrand.id || null,
              detail.isSearching ? null : detail.page,
              detail.isSearching ? null : LIMIT_PER_PAGE,
              detail.searchQuery
            ),
          ]);
          detail.setTypes(types);
          detail.setBrands(brands);
          if (detail.isSearching) {
            detail.setSearchResults(detailsData.rows);
          } else {
            detail.setDetails(detailsData.rows);
          }
          detail.setTotalCount(detailsData.count);
        } catch (error) {
          console.error("Error loading data:", error);
        } finally {
          detail.setIsLoading(false);
        }
      };
      loadData();
    }, [
      detail.page,
      detail.selectedType,
      detail.selectedSubType,
      detail.selectedBrand,
      detail.searchQuery,
  ]);


  return (
    <Container style={{ maxWidth: "1200px" }}>
      <Row>
        <SearchBar />
      </Row>
      
      <Row className="mt-2">
        <Col md={3}>
          {detail.isLoading ? <TypeBarSkeleton /> : <TypeBar />}
        </Col>
        
        <Col md={9}>
          {detail.isLoading ? <BrandBarSkeleton /> : <BrandBar />}
          
          {detail.isLoading ? (
            <DetailListSkeleton />
          ) : detail.isSearching && detail.searchResults.length === 0 ? (
            <div className="text-center py-5">
              <h4>Ничего не найдено</h4>
            </div>
          ) : (
            <DetailList />
          )}
          
          {!detail.isLoading && detail.totalCount > LIMIT_PER_PAGE && (
            <Pages />
          )}
        </Col>
      </Row>
    </Container>
  );
});

export default Shop;